import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { RouteKeys } from './route-keys';
import ListView from './ListView';
// import DetailsView from './DetailsView';

const AdminRouter: React.FunctionComponent = () => {
  return (
    <Switch>
      {/* <Route path={RouteKeys.Details} component={DetailsView} /> */}
      <Route path={RouteKeys.List} component={ListView} />
    </Switch>
  );
};

export default AdminRouter;
